export default __webpack_public_path__ + "static/media/printbillIcon.6e0d4099.svg";